import {
    replySubjectPrefix,
    forwardSubjectPrefix,
    approveSubjectPrefix,
    rejectSubjectPrefix,
} from './getRespondSubject.locstring.json';
import loc, { format } from 'owa-localize';

export default function getNormalizedSubject(subject: string): string {
    const subjectPrefixesRegex = new RegExp(
        format(
            '(^(?:(?:{0}|{1}|{2}|{3}))*)',
            loc(replySubjectPrefix),
            loc(forwardSubjectPrefix),
            loc(approveSubjectPrefix),
            loc(rejectSubjectPrefix)
        ),
        'gi'
    );

    return subject.replace(subjectPrefixesRegex, '');
}
